import React from 'react';
import LoadingComponentScalable from './LoadingComponentMini';

interface LoadingComponentProps {
  message?: string;
}

const LoadingComponent: React.FC<LoadingComponentProps> = ({ message }) => (
  <div
    style={{
      position:'absolute',
      top: 0,
      left: 0,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor:'#55555588',
      height: '100%',
      width:'100%',
      zIndex: 1000
    }}
  >
    <LoadingComponentScalable borderWidth={6} containerSize={100} message={message || 'Please wait'} />
  </div>
);

export default LoadingComponent;
